export default function debounce(callback, delay) {
  let timer;
  return function debounced() {
    clearTimeout(timer);
    timer = setTimeout(callback, delay, ...arguments);
  };
}
